import { useMemo } from 'react';

interface ArticleSourceProps {
  fonte: string;
}

function injectLinkSafety(html: string): string {
  return html.replace(/<a\b([^>]*)>/gi, (_match, attrs: string) => {
    let updated = attrs;

    if (!/\btarget\s*=/.test(updated)) {
      updated += ' target="_blank"';
    }

    if (!/\brel\s*=/.test(updated)) {
      updated += ' rel="noopener noreferrer"';
    }

    return `<a${updated}>`;
  });
}

export default function ArticleSource({ fonte }: ArticleSourceProps) {
  const html = useMemo(() => injectLinkSafety(fonte), [fonte]);

  if (!fonte?.trim()) return null;

  return (
    <section
      aria-label="Fontes"
      className="mt-8 border-t border-mglGray200 pt-4 text-sm text-mglGray500 [&_a]:text-mglBlue400 [&_a]:underline [&_a]:hover:text-mglBlue500"
    >
      <h3 className="mb-2 font-lexend text-base font-semibold text-mglGray700">Fonte</h3>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </section>
  );
}
